/**
 * Created by PuTi(编程即菩提) 3/4/17.
 */
var opts = {
    rootElementIdPrefix: 'nb-page-el-',
    appInitData: '__nb_app_init_data',
    clientReady: '__nb_client_ready'
};
module.exports = opts;



//////////////////
// WEBPACK FOOTER
// ../src/nb/core/js/config.js
// module id = 214
// module chunks = 35